import script from "./StandardDrawingTool.vue?vue&type=script&lang=js"
export * from "./StandardDrawingTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__